const DESTINATION_GOOGLE_ACCOUNT_CONNECTED =
  'Destination Google Account Connected';
const DESTINATION_GOOGLE_ACCOUNT_DISCONNECTED =
  'Destination Google Account Disconnected';
const DESTINATION_FOLDER_SELECTED = 'Destination Folder Selected';
const DESTINATION_FOLDER_DISCONNECTED = 'Destination Folder Disconnected';
const DESTINATION_FOLDERS_BULK_DISCONNECTED =
  'Destination Folders Bulk Disconnected';
const DESTINATION_ACTIVATION_FLOW_STARTED =
  'Destination Activation Flow Started';
const DESTINATION_ACTIVATION_FLOW_COMPLETED =
  'Destination Activation Flow Completed';

export const DESTINATION_ANALYTICS_EVENTS = {
  DESTINATION_GOOGLE_ACCOUNT_CONNECTED,
  DESTINATION_GOOGLE_ACCOUNT_DISCONNECTED,
  DESTINATION_FOLDER_SELECTED,
  DESTINATION_FOLDER_DISCONNECTED,
  DESTINATION_FOLDERS_BULK_DISCONNECTED,
  DESTINATION_ACTIVATION_FLOW_STARTED,
  DESTINATION_ACTIVATION_FLOW_COMPLETED,
};
